import { Breakpoints, styled } from "@vw-marketing/us-components";

export const LiteratureContainer: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      height: auto;
      width: ${theme.size.grid024};
      padding-bottom: 48px;

      @media (min-width: ${Breakpoints.b960}px) {
        padding-bottom: ${theme.size.static510};
      }
    `;
  }}
`;